import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserData } from "@/store/apps/userData/UserDataSlice";

// Enrichment can finish before the separate rate/expertise calculation job.
// Keep the shared profile current even when the profile editor is not open.
export function useAIEstimationSync(userSub) {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.user.profile?.ai_estimation_status);

  useEffect(() => {
    if (!userSub || status !== "pending") return undefined;

    let cancelled = false;
    let timer;
    const controller = new AbortController();
    const poll = async () => {
      try {
        const response = await fetch("/api/user/ai-estimation", {
          cache: "no-store",
          signal: controller.signal,
        });
        if (!response.ok) throw new Error("Could not check profile calculations");
        const data = await response.json();
        if (cancelled) return;
        if (data.status === "completed" || data.status === "failed") {
          // Refresh all calculated fields together, including partial results
          // from a failed job. Redux updating the status stops this effect.
          await dispatch(fetchUserData(true, { silent: true }));
        }
      } catch {
        // A temporary network error must not mark the calculation as failed.
        // Retry while the persisted profile still reports a pending job.
      }
      if (!cancelled) timer = setTimeout(poll, 3000);
    };

    poll();
    return () => {
      cancelled = true;
      controller.abort();
      clearTimeout(timer);
    };
  }, [dispatch, userSub, status]);
}
